import { CREATE_SUBSCRIPTION_WELLNESSPLAN } from "./create-subscription-wellnessplan.mutation";
import { ICreateSubscriptionWellnessPlanResponse } from "./create-subscription-wellnessplan.interface";
import { useMutation } from "@apollo/client";

export type ISubcriptionInput = {
  petId: string;
  cardId: string;
  planId: Number;
}

export const useCreateSubscriptionWellnessPlan = () => {
  const [createSubscriptionWellnessPlanV2, { data, loading, error, reset }] =
    useMutation<{createSubscriptionWellnessPlanV2:
       ICreateSubscriptionWellnessPlanResponse}>(CREATE_SUBSCRIPTION_WELLNESSPLAN);

  const createSubscription = (data: ISubcriptionInput) => {
    return createSubscriptionWellnessPlanV2({
      variables: {
        data,
      },
      context: { suppressGlobalErrorToast: true },
    });
  };

  return {
    createSubscription,
    response: data?.createSubscriptionWellnessPlanV2,
    loading,
    error,
    reset,
  };
};
